import { palette, spaces } from '@kimuno/theme';
import { Box, FormControl, FormLabel } from '@mui/material';
import { useEffect, useState } from 'react';
import { type Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import services from '../../../../services';
import FilterChip from '../../../modals/SearchFiltersDialog/FilterChip';
import type { CollectionFormValues } from '../../types';

interface SchoolStageWrapperProps {
	value?: string;
	onChange?: (value: string) => void;
	name?: string;
}

const SchoolStageWrapper = ({ value = '', onChange = () => {} }: SchoolStageWrapperProps) => {
	const [schoolStages, setSchoolStages] = useState<Array<{ name: string }>>([]);

	useEffect(() => {
		services.text.fetchSchoolStages().then((stages) => {
			setSchoolStages(stages);
		});
	}, []);

	return (
		<FormControl fullWidth>
			<Box
				sx={{
					display: 'flex',
					gap: spaces.xs,
					flexWrap: 'wrap',
					overflow: 'hidden',
				}}
			>
				{schoolStages.map((option) => (
					<Box key={option.name} data-testid={`filter-chip-${option.name}`}>
						<FilterChip
							isSelected={value === option.name}
							value={option.name}
							label={option.name}
							onClick={() => {
								onChange(option.name);
							}}
							dataTestId={`filter-chip-${option.name}-input-${value === option.name ? 'selected' : 'not-selected'}`}
						/>
					</Box>
				))}
			</Box>
		</FormControl>
	);
};

const CollectionSchoolStages = ({
	control,
	initialValue,
}: {
	control: Control<CollectionFormValues>;
	initialValue?: string;
}) => {
	const { t } = useTranslation();

	return (
		<Box>
			<FormLabel sx={{ color: palette.text.primary }}>{t('School Stage')}</FormLabel>
			<Controller
				name="schoolStage"
				control={control}
				defaultValue={initialValue || ''}
				render={({ field }) => (
					<SchoolStageWrapper value={field.value} onChange={field.onChange} name={field.name} />
				)}
			/>
		</Box>
	);
};

export default CollectionSchoolStages;
